var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6176 0.352185C9.86245 0.577756 10 0.883657 10 1.20262C10 1.52157 9.86245 1.82747 9.6176 2.05305L3.15257 8.00726L9.6176 13.9615C9.85551 14.1883 9.98716 14.4922 9.98418 14.8076C9.9812 15.123 9.84385 15.4247 9.60169 15.6477C9.35954 15.8707 9.03196 15.9972 8.68951 16C8.34706 16.0027 8.01715 15.8815 7.77082 15.6623L0.382399 8.85769C0.137549 8.63212 0 8.32622 0 8.00726C0 7.6883 0.137549 7.3824 0.382399 7.15683L7.77082 0.352185C8.01575 0.126681 8.34789 0 8.69421 0C9.04053 0 9.37268 0.126681 9.6176 0.352185Z",
    fill: "#50ABFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.7a46da35f26308b690823e9131e0b29f.svg";
export { ForwardRef as ReactComponent };